import { useEffect, useRef } from "react";

/**
 * useInViewAnimation
 * Toggles an "is-onscreen" class on the returned ref while the element
 * is within the viewport (with a margin). Pairs with CSS rules that
 * default continuous animations to `animation-play-state: paused` and
 * only run them when `.is-onscreen` is present — keeps infinite CSS
 * animations (orbit spin, particle float, glow pulse) from costing
 * compositor time while scrolled far off-screen.
 */
export default function useInViewAnimation() {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return undefined;
    if (typeof IntersectionObserver === "undefined") {
      ref.current.classList.add("is-onscreen");
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        entry.target.classList.toggle("is-onscreen", entry.isIntersecting);
      },
      { rootMargin: "200px 0px" }
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return ref;
}
